import Buttons from './Teaser/Buttons.es6';

(() => {
    class Teaser extends App.Component {
        constructor(container) {
            super(container);
            this.Buttons = new Buttons(this);
            this.render();
        }

        get id() { return this._id || (this._id = this.container.dataset.id) }

        async getValues() {
            if (this.id === undefined) return undefined;
            await App.Endpoint.Products.promise();
            return App.Endpoint.Products.getById(this.id);
        }

        render() {
            this.Buttons.render();
        }
    }
    App.Components.register(App.Components.selector('teaser'), Teaser);
})();
